<template>
  <section class="google_search">
    <paragraph-header size="2">{{ $t('pleaseEnterYourAddress') }}</paragraph-header>
    <div class="field">
      <input
        type="text"
        name="gsearch"
        placeholder=""
        autocomplete="off"
        :class="{ is_filled: addressName }"
        v-model="addressName"
        ref="address"
      />
      <label for="gsearch">{{ $t('City') }}, {{ $t('Address') }}</label>
    </div>
  </section>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
import { mapState } from 'vuex'
import ParagraphHeader from './atoms/ParagraphHeader.vue'
export default {
  components: { ParagraphHeader },
  data() {
    return {
      formattedAddress: {},
    }
  },
  created() {
    this.loadGoogleMaps()
  },
  computed: {
    ...mapState('user', {
      address: 'mapAddress',
      userCountry: 'shippingCountry',
    }),
    addressName: {
      set(value) {
        this.$store.commit('user/setMapAddressName', value)
      },
      get() {
        return this.$store.state.user.mapAddressName
      },
    },
  },
  methods: {
    loadGoogleMaps() {
      const loader = new Loader({
        apiKey: window.gm_object.key,
        version: 'weekly',
        libraries: ['places'],
      })

      loader.load().then((google) => this.autocomplete(google))
    },
    formatAddress() {
      if (!this.address) return true
      for (const component of this.address.address_components) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0]

        switch (componentType) {
          case 'route': {
            this.formattedAddress.street = `${component.short_name} ${this.formattedAddress?.streetNumber || ''}`
            break
          }

          case 'street_number': {
            this.formattedAddress.streetNumber = component.long_name
            break
          }

          case 'postal_code': {
            this.formattedAddress.postcode = component.long_name
            break
          }

          case 'locality':
            this.formattedAddress.city = component.long_name
            break

          // case 'administrative_area_level_1': {
          //   this.formattedAddress.administrative_area_level_1 = component.long_name
          //   break
          // }

          case 'country':
            this.formattedAddress.country = component.long_name
            break
        }
      }
    },
    autocomplete(google) {
      const options = {
        fields: ['formatted_address', 'geometry', 'name', 'address_components'],
        strictBounds: false,
        componentRestrictions: { country: this.userCountry },
        types: ['locality', 'route'],
      }

      const autocomplete = new google.maps.places.Autocomplete(this.$refs.address, options)

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace()
        this.$store.dispatch('user/setMapAddress', place)
        this.$store.dispatch('cart/setChildStepBySlug', 'deliveryType')
      })
    },
  },
  watch: {
    address() {
      this.formatAddress()
    },
  },
}
</script>

<style lang="scss" scoped>
section.google_search {
  @include container;
  position: relative;
}

.field {
  position: relative;
  max-width: 380px;
  z-index: 4;
}

h2 {
  display: inline-block;
  padding: 25px 0 20px;
  position: relative;
  z-index: 4;
  background-image: radial-gradient(circle at 51% 50%, #f6f1e3 0%, #f6f1e3 10%, rgba(245, 242, 231, 0) 100%);
}
</style>

<style>
.hdpi.pac-logo:after {
  display: none !important;
}

.pac-item {
  padding: 5px 10px;
}

.hdpi .pac-icon {
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg width="30px" height="42px" viewBox="0 0 30 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M15,0 C23.2842712,0 30,6.74747126 30,15.0708989 C30,17.943914 29.1998626,20.6291638 27.8112665,22.9139689 C26.2053387,25.556373 22.4970764,31.4367438 16.6864794,40.5550815 L16.6864794,40.5550815 C16.5321396,40.8023095 16.3237137,41.010902 16.0780521,41.1677002 C15.1469737,41.7619786 13.9104277,41.4889483 13.3161493,40.55787 L13.3161493,40.55787 L12.9969925,40.0545369 C7.38168097,31.2307356 3.7848623,25.5269525 2.20653653,22.9431874 C0.806978577,20.6520704 0,17.9561701 0,15.0708989 C0,6.74747126 6.71572875,0 15,0 Z M15,8.4 C11.3549207,8.4 8.4,11.3549207 8.4,15 C8.4,18.6450793 11.3549207,21.6 15,21.6 C18.6450793,21.6 21.6,18.6450793 21.6,15 C21.6,11.3549207 18.6450793,8.4 15,8.4 Z"></path></svg>');
  background-size: 10px 14px;
  margin-top: 4px;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
